<template>
	<div class="partyReported">
		<!-- 面包屑导航 -->
		<!-- <div class="mianbao">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/communityPrecisionServiceindex' }">社区服务</el-breadcrumb-item>
				<el-breadcrumb-item>投诉与建议服务</el-breadcrumb-item>
			</el-breadcrumb>
		</div> -->
		<div class="card-box">
			<!-- 右边卡片 -->
			<div class="card-rb">

				<div class="card-4">
					<el-card :body-style="{ padding: '16px' }">
						<div class="fisthang">
							<el-form :inline="true" :model="searchlist" class="demo-form-inline" size="mini">
								<el-form-item label="反馈类别:">
									<el-radio-group v-model="searchlist.category" @change="getData">
										<el-radio label="0">投诉</el-radio>
										<el-radio label="1">建议</el-radio>
									</el-radio-group>
								</el-form-item>
								<el-form-item label="处理状态:">
									<el-radio-group v-model="searchlist.status" @change="getData">
										<el-radio label="0">未处理</el-radio>
										<!-- <el-radio label="1">处理中</el-radio>
										<el-radio label="2">转批中</el-radio>
										<el-radio label="3">已处理</el-radio> -->
									</el-radio-group>
								</el-form-item>
								<!-- <el-form-item label="处理结果评价:">
									<el-select v-model="searchlist.evaluate" placeholder="请选择" @change="getData">
										<el-option v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item> -->
								<el-form-item label="反馈日期:">
									<el-date-picker @change="getData" style="width:250px" v-model="searchlist.registrationtime" value-format="yyyy-MM-dd"
													type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="searchlistdata">查询</el-button>
								</el-form-item>
								<el-form-item>
									<el-button type="info" @click="searchlistReset">重置</el-button>
								</el-form-item>
								<el-form-item></el-form-item>
							</el-form>
						</div>
						<div class="shoutwosearch" v-if="doshowsearchlistdata"></div>
						<div class="three">
							<el-button type="danger" @click="exportBtn" size="mini">导出Excel</el-button>
						</div>
						<!-- 表格盒子 -->
						<div class="table_card">
							<el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }" border align="center" current-row-key
									  highlight-current-row>
								<el-table-column type="index" align="center" label="序号" width="50">
									<template slot-scope="scope">
										{{scope.$index+1}}
									</template>
								</el-table-column>
								<el-table-column align="center" prop="categoryName" label="反馈类别">
								</el-table-column>
								<el-table-column align="center" prop="fkName" label="居民姓名"></el-table-column>
<!--								<el-table-column align="center" prop="targer" label="对象"></el-table-column>-->
								<el-table-column align="center" prop="phone" label="手机号"></el-table-column>
								<el-table-column align="center" prop="createDate" label="反馈日期"></el-table-column>
								<el-table-column align="center" prop="statusName" label="处理状态"></el-table-column>
								<el-table-column align="center" prop="evaluate" label="处理结果评价"></el-table-column>

								<el-table-column align="center" label="操作" width="200" fixed="right">
									<template scope="scope">
										<!-- tabBtnDetail -->
										<el-tooltip class="item" effect="light" content="删除" placement="top-start">
											<button class="iconfont el-icon-delete tabBtn tabBtnDetail"  @click="deteleBtn(scope.row.id)"></button>
										</el-tooltip>
										<!-- 包裹按钮的悬浮提示 -->
										<el-tooltip v-if="scope.row.status==0" class="item" effect="light" content="处理" placement="top-start">
											<button class="iconfont icon-bianji3 tabBtn tabBtnDeal" @click="dealBtn(scope.row.id)"></button>
										</el-tooltip>
<!--										<el-tooltip class="item" effect="light" content="转批" placement="top-start">-->
<!--											<button class="iconfont el-icon-set-up tabBtn tabBtnDeal" @click="transferBatch(scope.row.id)"></button>-->
<!--										</el-tooltip>-->
										<el-tooltip class="item" effect="light" content="查看" placement="top-start">
											<button class="iconfont icon-chakan tabBtn tabBtnCk"  @click="seeBtn(scope.row.id)"></button>
										</el-tooltip>
									</template>
								</el-table-column>
							</el-table>
							<!-- 分页功能 -->
							<!--background背景色 :page-sizes="[10,20]"页码选择器   layout显示什么内容  total总条数 -->
							<el-pagination :page-size="10" layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
										   :total="pageConfig.total"></el-pagination>
						</div>
					</el-card>
				</div>
			</div>
		</div>

		<modelCom ref="modelComRef" :editDialogVisible="editDialogVisible" :modelWord="modelWord" @closeBtn="closeBtn" @define="getData"></modelCom>
	</div>
</template>

<script>
	import modelCom from "./communityComplaintAdvice-dialog.vue"
	import {
		findComplaints,
		downloadOpinionPerson,
		deleteOpinionPerson,
		deleteComplaints
	} from "@/api/requrestHttp.js"
	import {downloadComplaints} from "@/api/http.js"
	export default {
		data() {
			return {
				editDialogVisible:false,
				modelWord:'',
				dealWord: '',
				dealShow: false, //处理弹出层
				dialogVisible: false, //新增弹窗
				//查询
				doshowsearchlistdata: false,
				searchlist: {
					state:'',
					evaluate:'',
					category:'',
					registrationtime:''
				},
				//表格数据
				tableData: [],
				// 分页配置
				pageConfig: {
					pageSize: 10,
					total: 0,
					pageNo: 1
				},

				shouthreetypedata: "",

				// 新增弹出层
				showadd: false,
				tanchuadd: {},
				categoryList: [{
					value: '0',
					label: '待评价'
				}, {
					value: '1',
					label: '不满意'
				}, {
					value: '2',
					label: '满意'
				}, {
					value: '3',
					label: '很满意'
				}],
			};
		},
		components: {
			modelCom
		},
		methods: {
			//条件查询
			searchlistdata() {
				this.pageConfig.pageNo = 1;
				this.getData();
			},
			searchlistReset() {
				this.searchlist = {};
				this.pageConfig.pageNo = 1;
				this.getData();
        	},
			closeBtn(data){
				this.editDialogVisible=data;
			},
			seeBtn(id) {
				this.modelWord = "查看"
				this.editDialogVisible = true;
				this.$refs.modelComRef.getDetail(id)
			},
			dealBtn(id) {
				this.modelWord = "处理"
				this.editDialogVisible = true;
				this.$refs.modelComRef.getDetail(id)
			},
			transferBatch(id){
				this.modelWord = "转批"
				this.editDialogVisible = true;
				this.$refs.modelComRef.getDetail(id)
			},
			closes(data) {
				this.dealShow = data
			},
			close(data) {
				this.dialogVisible = data
			},
			// 获取意见列表
			async getData() {
				this.tableData = [];
				let data = {
					pageSize: this.pageConfig.pageSize,
					pageNo: this.pageConfig.pageNo
				}
				if (this.searchlist.status) {
					data.status = this.searchlist.status
				}
				if (this.searchlist.evaluate) {
					data.evaluate = this.searchlist.evaluate
				}
				if (this.searchlist.category) {
					data.category = this.searchlist.category
				}
				if (this.searchlist.registrationtime) {
					data.startFeedbackDate = this.searchlist.registrationtime[0]
					data.endFeedbackDate = this.searchlist.registrationtime[1]
				}
				let res = await findComplaints(data);
				if (res.code == 200) {
					if (!res.content) {
						this.$message({
							message: res.message,
							type: "error"
						});
					}
					res.content.list.forEach(item => {
						if (item.category == 0) {
							item.categoryName = "投诉"
						} else if (item.category == 1) {
							item.categoryName = "建议"
						}

						if (item.status == 0) {
							item.statusName = "未处理"
						} else if (item.status == 1) {
							item.statusName = "处理中"
						} else if (item.status == 2) {
							item.statusName = "转批中"
						} else if (item.status == 3) {
							item.statusName = "已处理"
						}

						if (item.evaluate == 0) {
							item.evaluateName = "待评价"
						} else if (item.evaluate == 1) {
							item.evaluateName = "不满意"
						} else if (item.evaluate == 2) {
							item.evaluateName = "满意"
						} else if (item.evaluate == 3) {
							item.evaluateName = "很满意"
						}

					})
					this.tableData = res.content.list;
					this.pageConfig.total = res.content.count
				} else {
					this.$message({
						message: res.message,
						type: "error"
					});
				}
			},
			// 导出Excel
			async exportBtn() {
				let data = {
					status:this.searchlist.state,
					evaluate:this.searchlist.evaluate,
					category:this.searchlist.category,
					startFeedbackDate:'',
					endFeedbackDate:''
				}
				let res = await downloadComplaints(data);
				const blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				const fileName = '投诉与建议基本信息.xls';
				const linkNode = document.createElement('a');

				linkNode.download = fileName; //a标签的download属性规定下载文件的名称
				linkNode.style.display = 'none';
				linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
				document.body.appendChild(linkNode);
				linkNode.click(); //模拟在按钮上的一次鼠标单击

				URL.revokeObjectURL(linkNode.href); // 释放URL 对象
				document.body.removeChild(linkNode);
				console.log(res);

				// this.$http.post('/admin/opinionCollection/info/downloadOpinionPerson', data).then(res => {

				// })
			},
			// 删除
			deteleBtn(id) {

				this.$confirm('确定删除该意见, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.aginDeteleBtn(id);
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			async aginDeteleBtn(id) {
				let res = await deleteComplaints({
					id
				})
				if (res.code == 200) {
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
					this.getData();
				} else {
					this.$message({
						message: res.message,
						type: "error"
					});
				}
			},
			//查询更多
			doshowsearchlist() {
				if (this.doshowsearchlistdata) {
					this.doshowsearchlistdata = false;
				} else {
					this.doshowsearchlistdata = true;
				}
			},
			//分页
			handleCurrentChange(val) {
				this.pageConfig.pageNo = val;
				this.getData();
			},
			dosomepage() {},

			//显示缴费弹出框
			showbillpanduan(somename) {
				if (somename == "未缴费" || somename == "即将逾期") {
					this.showbill = true;
				}
			},

			//清空缴费数据
			clearbilldata() {
				this.showbill = false;
			},

			//清空增加的信息
			clearadddata() {
				this.showadd = false;
			},
			//获取新增所有数据发请求
			saveadddata() {},
			//点击查看显示弹出层
			showcheckpanduan(id) {
				this.showcheck = true;
			},
			//点击编辑显示编辑弹出层
			showredactpanduan(id) {
				this.showredact = true;
			}
		},
		mounted() {
			this.getData();
		}
	};
</script>

<style lang="less" scoped>
	.partyReported {
		background-color: #eef1f6;
		padding: 16px;
		box-sizing: border-box;
		width: 100%;
		/*min-width: 1381px;*/
	}

	// 面包屑导航box
	.mianbao {
		box-sizing: border-box;
		margin: -16px -16px 0;
		background-color: #fff;
		height: 47px;
		display: flex;
		align-items: center;
		padding-left: 16px;
		margin-bottom: 16px;
	}

	//  包裹两个卡片的盒子
	.card-box {
		display: flex;

		// 左边树状列表卡片
		.card-l {
			width: 270px;
		}

		// 右边卡片
		.card-rb {
			// width: calc(100% - 270px);
			width: 100%;
		}

		.card-r {
			// overflow: hidden;
			flex: 1;
			margin-left: 16px;
			height: 320px;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;

			.card-0 {
				width: 32.5%;
				height: 320px;

				.onebuttom {
					height: 258px;
				}
			}

			.card-2 {
				width: 32.5%;
				height: 320px;

				.onebuttom {
					height: 258px;

					// background-color: red;
					div {
						width: 100%;
						height: 100%;
					}
				}
			}

			.card-3 {
				width: 32.5%;
				height: 320px;

				.onebuttom {
					height: 258px;
				}
			}

			.topbarnav {
				display: flex;
				align-items: center;

				div {
					box-sizing: border-box;
					padding: 0 10px;
					font-size: 14px;
				}
			}
		}
	}

	.card-4 {
		width: 100%;
		// height: 320px;
		padding-left: 16px;
		box-sizing: border-box;
		padding-top: 16px;
	}

	// 表格的盒子
	.table_card {
		// overflow: hidden;
		// 解决表格无法自适应宽度
		// width: calc(100vw - 500px);
		margin: 16px 0 0 0;

		.el-table {
			width: 100%;

			// 表格里的按钮
			.tabBtn {
				margin: 0 6px;
			}

			.tabBtnDeal {
				color: #199b5d;
			}

			// .tabBtn:nth-child(2) {
			// 	color: #a1a1a1;
			// }

			.tabBtnDetail {
				color: #dd3020;
			}

			.tabBtnCk {
				color: #2e99cf;
			}

			.active_Btn {
				color: #ff04ed !important;
			}
		}
	}

	.active_tab {
		color: #cd2b20 !important;
	}

	.active_tab1 {
		color: #0f7ef1 !important;
	}

	.active_tab2 {
		color: #1a9c5e !important;
	}

	.boontbtn {
		margin-top: 30px;
		display: flex;
		justify-content: center;
	}
</style>
<style lang="less">
	.main[data-v-336d350d] {
		/*min-width: 1578px !important;*/
	}

	.partyReported {
		.el-form--inline .el-form-item {
			display: inline-block;
			margin-right: 10px !important;
			vertical-align: top;
		}

		.partyReported .el-form--inline .el-form-item {
			display: inline-block;
			margin-right: 10px !important;
			vertical-align: top;
		}

		.el-dialog__header {
			height: 40px;
			padding: 1px;
			background-color: #01aaef;
		}

		.el-dialog__headerbtn {
			position: absolute;
			top: 8px;
			right: 20px;
			padding: 0;
			background: 0 0;
			border: none;
			outline: 0;
			cursor: pointer;
			font-size: 24px;
		}

		.el-dialog__title {
			display: block;
			margin-top: 9px;
			margin-left: 10px;
			color: #fff;
			font-size: 15px;
		}

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
		}
	}
</style>

<style scoped>
/deep/.el-pagination{
	margin-top: 20px !important;
}
</style>
